var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
define('areas/informationrequest/models/bindable',["require", "exports"], function (require, exports) {
    "use strict";
    var BaseSectionVM = (function () {
        function BaseSectionVM() {
            this.isChecked = ko.observable(false);
            this.viewBreakdown = ko.observable(false);
            this.isFromHmrc = ko.observable(false);
            this.children = [];
            this.comments = [];
            //public attachments: Array<Attachment> = [];
            this.seeMore = ko.observable(false);
            this.expanded = ko.observable(false);
            this.mouseOver = ko.observable(false);
            this.enclosedPressed = ko.observable(false);
            this.commentsCount = ko.observable(0);
            this.attachmentsCount = ko.observable(0);
            //public hasWarningSpouse = ko.observable(true);
            this.hasWarningInvalidFname = ko.observable(false);
            this.hasWarningInvalidSurname = ko.observable(false);
            this.hasWarningInvalidNINO = ko.observable(false);
            this.hasWarningInvalidDom = ko.observable(false);
            this.hasWarningInvalidDob = ko.observable(false);
            this.hasWarningMissingFName = ko.observable(true);
            this.hasWarningMissingSurName = ko.observable(true);
            this.hasWarningMissingNINO = ko.observable(true);
            this.hasWarningMissingdom = ko.observable(true);
            this.hasWarningMissingdob = ko.observable(true);
            this.completeFromWeb = ko.observable(true);
            this.hasNotification = ko.observable(false);
            this.hasClientNotification = false;
            this.hasHMRCAPIError = ko.observable(false);
            this.hasHMRCAPI404Error = ko.observable(false);
            this.beforeUnloadPrompt = ko.observable("You forgot to save your work");
            this.isJointlyOwned = ko.observable(false);
            this.jointShare = ko.observable('100%');
            this.committed_Date = ko.observable("");
            this.foreignCurrency = ko.observable("");
            this.foreignCountry = ko.observable("");
            this.RentalIncome = ko.observable("");
            this.OtherIncome = ko.observable("");
            this.PrevRentalIncome = ko.observable("");
            this.PrevOtherIncome = ko.observable("");
            this.SumIncomeFromProperty = ko.computed(function () {
                var otherIncome = this.OtherIncome() != null ? this.OtherIncome().toString().replace(/,|£| /g, '') : "";
                var rentalIncome = this.RentalIncome() != null ? this.RentalIncome().toString().replace(/,|£| /g, '') : "";
                if (this.extrafields != null && this.extrafields.keyValueStore != null) {
                    if (this.PrevOtherIncome() !== otherIncome) {
                        this.PrevOtherIncome(this.extrafields.keyValueStore.otherIncome);
                        this.extrafields.keyValueStore.otherIncome = otherIncome;
                    }
                    if (this.PrevRentalIncome() !== rentalIncome) {
                        this.PrevRentalIncome(this.extrafields.keyValueStore.rentalIncome);
                        this.extrafields.keyValueStore.rentalIncome = rentalIncome;
                    }
                }
                otherIncome = isNaN(Number(otherIncome)) ? 0 : otherIncome;
                rentalIncome = isNaN(Number(rentalIncome)) ? 0 : rentalIncome;
                return (Number(otherIncome) + Number(rentalIncome)).toFixed(2);
            }, this);
            this.CouncilTax = ko.observable("");
            this.Repairs = ko.observable("");
            this.WaterRates = ko.observable("");
            this.Insurance = ko.observable("");
            this.GroundRent = ko.observable("");
            this.CostsOfServicesProvided = ko.observable("");
            this.Wages = ko.observable("");
            this.MortgageInterest = ko.observable("");
            this.LegalFees = ko.observable("");
            this.ManagementFees = ko.observable("");
            this.OtherPropertyExpenses = ko.observable("");
            this.OtherProfessionalCosts = ko.observable("");
            this.OtherFinancialCosts = ko.observable("");
            this.PrevCouncilTax = ko.observable("");
            this.PrevRepairs = ko.observable("");
            this.PrevWaterRates = ko.observable("");
            this.PrevInsurance = ko.observable("");
            this.PrevGroundRent = ko.observable("");
            this.PrevCostsOfServicesProvided = ko.observable("");
            this.PrevWages = ko.observable("");
            this.PrevMortgageInterest = ko.observable("");
            this.PrevLegalFees = ko.observable("");
            this.PrevManagementFees = ko.observable("");
            this.PrevOtherPropertyExpenses = ko.observable("");
            this.PrevOtherProfessionalCosts = ko.observable("");
            this.PrevOtherFinancialCosts = ko.observable("");
            this.SumExpensesFromProperty = ko.computed(function () {
                var councilTax = this.CouncilTax() != null ? this.CouncilTax().toString().replace(/,|£| /g, '') : "";
                var repairs = this.Repairs() != null ? this.Repairs().toString().replace(/,|£| /g, '') : "";
                var waterRates = this.WaterRates() != null ? this.WaterRates().toString().replace(/,|£| /g, '') : "";
                var insurance = this.Insurance() != null ? this.Insurance().toString().replace(/,|£| /g, '') : "";
                var groundRent = this.GroundRent() != null ? this.GroundRent().toString().replace(/,|£| /g, '') : "";
                var costsOfServicesProvided = this.CostsOfServicesProvided() != null ? this.CostsOfServicesProvided().toString().replace(/,|£| /g, '') : "";
                var wages = this.Wages() != null ? this.Wages().toString().replace(/,|£| /g, '') : "";
                var legalFees = this.LegalFees() != null ? this.LegalFees().toString().replace(/,|£| /g, '') : "";
                var managementFees = this.ManagementFees() != null ? this.ManagementFees().toString().replace(/,|£| /g, '') : "";
                var mortgageInterest = this.MortgageInterest() != null ? this.MortgageInterest().toString().replace(/,|£| /g, '') : "";
                var otherPropertyExpenses = this.OtherPropertyExpenses() != null ? this.OtherPropertyExpenses().toString().replace(/,|£| /g, '') : "";
                var otherProfessionalCosts = this.OtherProfessionalCosts() != null ? this.OtherProfessionalCosts().toString().replace(/,|£| /g, '') : "";
                var otherFinancialCosts = this.OtherFinancialCosts() != null ? this.OtherFinancialCosts().toString().replace(/,|£| /g, '') : "";
                if (this.extrafields != null && this.extrafields.keyValueStore != null) {
                    if (this.PrevCouncilTax() !== councilTax) {
                        this.PrevCouncilTax(this.extrafields.keyValueStore.councilTax);
                        this.extrafields.keyValueStore.councilTax = councilTax;
                    }
                    if (this.PrevRepairs() !== repairs) {
                        this.PrevRepairs(this.extrafields.keyValueStore.repairs);
                        this.extrafields.keyValueStore.repairs = repairs;
                    }
                    if (this.PrevWaterRates() !== waterRates) {
                        this.PrevWaterRates(this.extrafields.keyValueStore.waterRates);
                        this.extrafields.keyValueStore.waterRates = waterRates;
                    }
                    if (this.PrevInsurance() !== insurance) {
                        this.PrevInsurance(this.extrafields.keyValueStore.insurance);
                        this.extrafields.keyValueStore.insurance = insurance;
                    }
                    if (this.PrevGroundRent() !== groundRent) {
                        this.PrevGroundRent(this.extrafields.keyValueStore.groundRent);
                        this.extrafields.keyValueStore.groundRent = groundRent;
                    }
                    if (this.PrevCostsOfServicesProvided() !== costsOfServicesProvided) {
                        this.PrevCostsOfServicesProvided(this.extrafields.keyValueStore.costsOfServicesProvided);
                        this.extrafields.keyValueStore.costsOfServicesProvided = costsOfServicesProvided;
                    }
                    if (this.PrevWages() !== wages) {
                        this.PrevWages(this.extrafields.keyValueStore.wages);
                        this.extrafields.keyValueStore.wages = wages;
                    }
                    if (this.PrevLegalFees() !== legalFees) {
                        this.PrevLegalFees(this.extrafields.keyValueStore.legalFees);
                        this.extrafields.keyValueStore.legalFees = legalFees;
                    }
                    if (this.PrevManagementFees() !== managementFees) {
                        this.PrevManagementFees(this.extrafields.keyValueStore.managementFees);
                        this.extrafields.keyValueStore.managementFees = managementFees;
                    }
                    if (this.PrevMortgageInterest() !== mortgageInterest) {
                        this.PrevMortgageInterest(this.extrafields.keyValueStore.mortgageInterest);
                        this.extrafields.keyValueStore.mortgageInterest = mortgageInterest;
                    }
                    if (this.PrevOtherPropertyExpenses() !== otherPropertyExpenses) {
                        this.PrevOtherPropertyExpenses(this.extrafields.keyValueStore.otherPropertyExpenses);
                        this.extrafields.keyValueStore.otherPropertyExpenses = otherPropertyExpenses;
                    }
                    if (this.PrevOtherProfessionalCosts() !== otherProfessionalCosts) {
                        this.PrevOtherProfessionalCosts(this.extrafields.keyValueStore.otherProfessionalCosts);
                        this.extrafields.keyValueStore.otherProfessionalCosts = otherProfessionalCosts;
                    }
                    if (this.PrevOtherFinancialCosts() !== otherFinancialCosts) {
                        this.PrevOtherFinancialCosts(this.extrafields.keyValueStore.otherFinancialCosts);
                        this.extrafields.keyValueStore.otherFinancialCosts = otherFinancialCosts;
                    }
                }
                councilTax = isNaN(Number(councilTax)) ? 0 : councilTax;
                repairs = isNaN(Number(repairs)) ? 0 : repairs;
                waterRates = isNaN(Number(waterRates)) ? 0 : waterRates;
                insurance = isNaN(Number(insurance)) ? 0 : insurance;
                groundRent = isNaN(Number(groundRent)) ? 0 : groundRent;
                costsOfServicesProvided = isNaN(Number(costsOfServicesProvided)) ? 0 : costsOfServicesProvided;
                wages = isNaN(Number(wages)) ? 0 : wages;
                legalFees = isNaN(Number(legalFees)) ? 0 : legalFees;
                managementFees = isNaN(Number(managementFees)) ? 0 : managementFees;
                mortgageInterest = isNaN(Number(mortgageInterest)) ? 0 : mortgageInterest;
                otherPropertyExpenses = isNaN(Number(otherPropertyExpenses)) ? 0 : otherPropertyExpenses;
                otherProfessionalCosts = isNaN(Number(otherProfessionalCosts)) ? 0 : otherProfessionalCosts;
                otherFinancialCosts = isNaN(Number(otherFinancialCosts)) ? 0 : otherFinancialCosts;
                //User Story 187538: [Advisor] Update the calculations to NOT included "Mortgage Interest" amount
                mortgageInterest = this.taxYear >= 2021 ? 0 : mortgageInterest;
                return (Number(councilTax) + Number(repairs) + Number(waterRates) + Number(insurance) + Number(groundRent) + Number(costsOfServicesProvided)
                    + Number(wages) + Number(mortgageInterest) + Number(otherPropertyExpenses) + Number(otherProfessionalCosts) + Number(otherFinancialCosts)
                    + Number(managementFees) + Number(legalFees)).toFixed(2);
            }, this);
            this.SumNetIncome = ko.computed(function () {
                var totalSumIncomeFromProperty = isNaN(Number(this.SumIncomeFromProperty())) ? 0 : Number(this.SumIncomeFromProperty());
                var totalSumExpensesFromProperty = isNaN(Number(this.SumExpensesFromProperty())) ? 0 : Number(this.SumExpensesFromProperty());
                return (totalSumIncomeFromProperty - totalSumExpensesFromProperty).toFixed(2);
            }, this);
            this.beforeUnloadText = ko.bindingHandlers.beforeUnloadText = {
                init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
                    if (window.onbeforeunload == null) {
                        window.onbeforeunload = function () {
                            var value = valueAccessor();
                            var promptText = ko.utils.unwrapObservable(value);
                            if (typeof promptText == "undefined" || promptText == null) {
                            }
                            else {
                                if (promptText != null && typeof promptText != "string") {
                                    var err = "Error: beforeUnloadText binding must be " +
                                        "against a string or string observable.  " +
                                        "Binding was done against a " + typeof promptText;
                                    console.log(err);
                                    console.log(promptText);
                                    // By returning the error string, it will display in the
                                    // onbeforeunload dialog box to the user.  We could throw an
                                    // exception here, but the page would unload and the
                                    // exception would be lost.
                                    return err;
                                }
                                return promptText;
                            }
                        };
                    }
                    else {
                        var err = "onbeforeupload has already been set";
                        throw new Error(err);
                    }
                }
            };
            this.checkboxVisible = false;
            this.shortDetails = "";
            this.togleDetails = false;
            this.hasSpouse = false;
            this.hasLastYearValue = false;
            this.isTaxDeductionVisible = false;
        }
        BaseSectionVM.prototype.UnmaskAmount = function () {
            if (this.extrafields.alias == "DefaultExtraFields" || this.extrafields.alias == "Employment" ||
                this.extrafields.alias == "ForeignIncome" ||
                this.extrafields.alias == "JointlyOwned" || this.extrafields.alias == "JointlyOwnedForeignIncome") {
                this.extrafields.keyValueStore.currentYear = this.extrafields.keyValueStore.currentYear != null ? this.extrafields.keyValueStore.currentYear.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.taxDeducted = this.extrafields.keyValueStore.taxDeducted != null ? this.extrafields.keyValueStore.taxDeducted.toString().replace(/,|£| /g, '') : null;
            }
            if (this.extrafields.alias == "ChildBenefit") {
                this.extrafields.keyValueStore.currentYear = this.extrafields.keyValueStore.currentYear != null ? this.extrafields.keyValueStore.currentYear.toString().replace(/,|£| /g, '') : null;
            }
            if (this.extrafields.alias == "LandAndProperty") {
                this.extrafields.keyValueStore.currentYear = this.extrafields.keyValueStore.currentYear != null ? this.extrafields.keyValueStore.currentYear.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.taxDeducted = this.extrafields.keyValueStore.taxDeducted != null ? this.extrafields.keyValueStore.taxDeducted.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.jointlyOwnedShare = this.extrafields.keyValueStore.jointlyOwnedShare != null ? this.extrafields.keyValueStore.jointlyOwnedShare.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.clientCategory = this.extrafields.keyValueStore.clientCategory != null ? this.extrafields.keyValueStore.clientCategory.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.rentalIncome = this.extrafields.keyValueStore.rentalIncome != null ? this.extrafields.keyValueStore.rentalIncome.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.otherIncome = this.extrafields.keyValueStore.otherIncome != null ? this.extrafields.keyValueStore.otherIncome.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.councilTax = this.extrafields.keyValueStore.councilTax != null ? this.extrafields.keyValueStore.councilTax.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.waterRates = this.extrafields.keyValueStore.waterRates != null ? this.extrafields.keyValueStore.waterRates.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.insurance = this.extrafields.keyValueStore.insurance != null ? this.extrafields.keyValueStore.insurance.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.groundRent = this.extrafields.keyValueStore.groundRent != null ? this.extrafields.keyValueStore.groundRent.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.repairs = this.extrafields.keyValueStore.repairs != null ? this.extrafields.keyValueStore.repairs.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.mortgageInterest = this.extrafields.keyValueStore.mortgageInterest != null ? this.extrafields.keyValueStore.mortgageInterest.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.otherFinancialCosts = this.extrafields.keyValueStore.otherFinancialCosts != null ? this.extrafields.keyValueStore.otherFinancialCosts.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.legalFees = this.extrafields.keyValueStore.legalFees != null ? this.extrafields.keyValueStore.legalFees.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.managementFees = this.extrafields.keyValueStore.managementFees != null ? this.extrafields.keyValueStore.managementFees.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.otherProfessionalCosts = this.extrafields.keyValueStore.otherProfessionalCosts != null ? this.extrafields.keyValueStore.otherProfessionalCosts.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.costsOfServicesProvided = this.extrafields.keyValueStore.costsOfServicesProvided != null ? this.extrafields.keyValueStore.costsOfServicesProvided.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.wages = this.extrafields.keyValueStore.wages != null ? this.extrafields.keyValueStore.wages.toString().replace(/,|£| /g, '') : null;
                this.extrafields.keyValueStore.otherPropertyExpenses = this.extrafields.keyValueStore.otherPropertyExpenses != null ? this.extrafields.keyValueStore.otherPropertyExpenses.toString().replace(/,|£| /g, '') : null;
            }
        };
        return BaseSectionVM;
    }());
    exports.BaseSectionVM = BaseSectionVM;
    var SectionVM = (function (_super) {
        __extends(SectionVM, _super);
        function SectionVM() {
            _super.call(this);
        }
        return SectionVM;
    }(BaseSectionVM));
    exports.SectionVM = SectionVM;
    var HmrcSectionVM = (function (_super) {
        __extends(HmrcSectionVM, _super);
        function HmrcSectionVM() {
            _super.call(this);
            this.isVisible = ko.observable(true);
            this.showChevron = ko.observable(true);
            this.lasthmrcvalue = ko.observable();
            this.hashmrcvalue = ko.computed(function () {
                return this.lasthmrcvalue() != null && this.lasthmrcvalue() != "" && this.lasthmrcvalue() != "Details missing";
            }, this);
            this.isAmountNic = false;
            this.isHipperLink = false;
            this.hasHmrcIcon = false;
        }
        return HmrcSectionVM;
    }(BaseSectionVM));
    exports.HmrcSectionVM = HmrcSectionVM;
    var Client = (function () {
        function Client() {
            this.mouseOver = ko.observable(false);
            this.index = ko.observable(0);
            this.latestComments = "";
        }
        Client.prototype.setRequestStatusIconPath = function (requestStatusId) {
            if (requestStatusId === void 0) { requestStatusId = this.requestStatusId; }
            var path = "/html/content/images/inforeq-requeststatus-";
            switch (requestStatusId) {
                case 0:
                    path += "requestsent.svg";
                    break;
                case 1:
                    path += "clientviewed.svg";
                    break;
                case 2:
                    path += "clientupdated.svg";
                    break;
                case 3:
                    path += "readyforreview.svg";
                    break;
                case 4:
                    path += "requestcompleted.svg";
                    break;
            }
            this.requestStatusIconPath = path;
        };
        return Client;
    }());
    exports.Client = Client;
    var InformationRequest = (function () {
        function InformationRequest() {
            this.Sections = [];
        }
        return InformationRequest;
    }());
    exports.InformationRequest = InformationRequest;
    var Comment = (function () {
        function Comment() {
        }
        return Comment;
    }());
    exports.Comment = Comment;
    var Attachment = (function () {
        function Attachment() {
        }
        return Attachment;
    }());
    exports.Attachment = Attachment;
    var SpouseInfo = (function () {
        function SpouseInfo() {
        }
        SpouseInfo.prototype.IsEqual = function (spouse) {
            if (spouse == null)
                return false;
            return this.spouseFName == spouse.spouseFName &&
                this.spouseDOB == spouse.spouseDOB &&
                this.spouseSurname == spouse.spouseSurname &&
                this.spouseNINO == spouse.spouseNINO &&
                this.dom == spouse.dom;
        };
        SpouseInfo.prototype.getModelForExport = function () {
            var model = new SpouseInfo();
            model.spouseFName = this.spouseFName;
            model.spouseSurname = this.spouseSurname;
            model.spouseNINO = this.spouseNINO;
            model.spouseDOB = this.getFullDateString(this.spouseDOB);
            model.dom = this.getFullDateString(this.dom);
            return model;
        };
        SpouseInfo.isEmpty = function (spouseInfo) {
            if (spouseInfo == null)
                return true;
            return (spouseInfo.spouseFName == null || spouseInfo.spouseFName == "") &&
                (spouseInfo.spouseSurname == null || spouseInfo.spouseSurname == "") &&
                (spouseInfo.spouseNINO == null || spouseInfo.spouseNINO == "") &&
                (spouseInfo.spouseDOB == null || spouseInfo.spouseDOB == "") &&
                (spouseInfo.dom == null || spouseInfo.dom == "");
        };
        SpouseInfo.prototype.getFullDateString = function (date) {
            if (date == null || date == "" || date == "-")
                return "";
            return moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
        };
        SpouseInfo.loadFromInfoRequest = function (spouseInfo) {
            var spObj = new SpouseInfo;
            if (spouseInfo == null)
                return spObj;
            var dobDate = new Date(spouseInfo.spouseDOB);
            var domDate = new Date(spouseInfo.dom);
            if (spouseInfo.spouseDOB == "" || dobDate.getFullYear() <= 1900)
                spObj.spouseDOB = "-";
            else {
                var date = new Date(Date.parse(spouseInfo.spouseDOB.toString()));
                spObj.spouseDOB = date.toLocaleDateString('en-GB');
            }
            if (spouseInfo.dom == null || spouseInfo.dom == "" || domDate.getFullYear() <= 1900)
                spObj.dom = "-";
            else {
                var date = new Date(Date.parse(spouseInfo.dom.toString()));
                spObj.dom = date.toLocaleDateString('en-GB');
            }
            if (spouseInfo.spouseNINO == "")
                spObj.spouseNINO = "-";
            else {
                spObj.spouseNINO = spouseInfo.spouseNINO;
            }
            if (spouseInfo.spouseFName == "")
                spObj.spouseFName = "-";
            else {
                spObj.spouseFName = spouseInfo.spouseFName;
            }
            if (spouseInfo.spouseSurname == "")
                spObj.spouseSurname = "-";
            else {
                spObj.spouseSurname = spouseInfo.spouseSurname;
            }
            return spObj;
        };
        return SpouseInfo;
    }());
    exports.SpouseInfo = SpouseInfo;
    var FilterTaxYear = (function () {
        function FilterTaxYear() {
            this.isDisabled = ko.observable(false);
        }
        return FilterTaxYear;
    }());
    exports.FilterTaxYear = FilterTaxYear;
    var RequestStatus = (function () {
        function RequestStatus() {
        }
        return RequestStatus;
    }());
    exports.RequestStatus = RequestStatus;
    var Guid = (function () {
        function Guid() {
        }
        Guid.newGuid = function () {
            return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
                return v.toString(16);
            });
        };
        return Guid;
    }());
    exports.Guid = Guid;
    var Employee = (function () {
        function Employee() {
        }
        return Employee;
    }());
    exports.Employee = Employee;
    var TaxYearParameters = (function () {
        function TaxYearParameters() {
        }
        return TaxYearParameters;
    }());
    exports.TaxYearParameters = TaxYearParameters;
});

